const PhoneCall = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#3293DB' fill-opacity='0.4' />
      <g clip-path='url(#clip0_2147_6999)'>
        <path
          d='M13.1957 8.49984C13.7655 8.611 14.2891 8.88965 14.6996 9.30013C15.1101 9.71061 15.3887 10.2342 15.4999 10.804M13.1957 6.1665C14.3795 6.29801 15.4833 6.82811 16.326 7.66976C17.1687 8.51141 17.7002 9.61459 17.8332 10.7982M10.9656 13.0866C10.2647 12.3857 9.71124 11.5932 9.30524 10.7476C9.27032 10.6748 9.25286 10.6385 9.23944 10.5924C9.19177 10.4289 9.22601 10.2281 9.32519 10.0896C9.3531 10.0506 9.38644 10.0173 9.45312 9.95058C9.65706 9.74664 9.75902 9.64467 9.82569 9.54213C10.0771 9.15545 10.0771 8.65694 9.82569 8.27026C9.75902 8.16772 9.65706 8.06575 9.45312 7.86181L9.33944 7.74814C9.02944 7.43813 8.87443 7.28313 8.70796 7.19893C8.37688 7.03147 7.9859 7.03147 7.65482 7.19893C7.48835 7.28313 7.33334 7.43813 7.02333 7.74814L6.93138 7.84009C6.62243 8.14904 6.46796 8.30351 6.34998 8.51353C6.21907 8.74658 6.12494 9.10853 6.12574 9.37583C6.12645 9.61671 6.17318 9.78134 6.26664 10.1106C6.76887 11.8801 7.71648 13.5498 9.10947 14.9428C10.5025 16.3358 12.1722 17.2834 13.9416 17.7856C14.2709 17.8791 14.4355 17.9258 14.6764 17.9265C14.9437 17.9273 15.3057 17.8332 15.5387 17.7023C15.7487 17.5843 15.9032 17.4298 16.2122 17.1209L16.3041 17.0289C16.6141 16.7189 16.7691 16.5639 16.8533 16.3974C17.0208 16.0664 17.0208 15.6754 16.8533 15.3443C16.7691 15.1778 16.6141 15.0228 16.3041 14.7128L16.1904 14.5991C15.9865 14.3952 15.8845 14.2932 15.782 14.2266C15.3953 13.9751 14.8968 13.9751 14.5101 14.2266C14.4076 14.2932 14.3056 14.3952 14.1017 14.5991C14.035 14.6658 14.0016 14.6992 13.9627 14.7271C13.8242 14.8262 13.6234 14.8605 13.4598 14.8128C13.4138 14.7994 13.3774 14.7819 13.3047 14.747C12.4591 14.341 11.6665 13.7875 10.9656 13.0866Z'
          stroke='#3293DB'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2147_6999'>
          <rect
            width='14'
            height='14'
            fill='white'
            transform='translate(5 5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PhoneCall;
